/**
 * Nutriline lactation PDP
 * The lactation checkout uses a native Shopify cart form, so cart, remove,
 * and checkout always use Shopify's server-rendered cart state.
 */
(function () {
  'use strict';

  function gidNum(gid) {
    return String(gid).split('/').pop();
  }

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      var v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  function trackPixel(eventName, params, eventID) {
    if (typeof window.fbq !== 'function') return eventID;
    var id = eventID || uuid();
    var payload = Object.assign({ currency: 'INR' }, params || {});
    try {
      fbq('track', eventName, payload, { eventID: id });
    } catch (e) {}
    return id;
  }

  window.NLLactationPixel = {
    uuid: uuid,
    track: trackPixel,
    viewContent: function (data) {
      return trackPixel('ViewContent', {
        content_type: 'product',
        content_ids: [String(data.variantId)],
        content_name: data.title || '',
        value: Number(data.valueInr),
        currency: 'INR',
        contents: [{ id: String(data.variantId), quantity: 1, item_price: Number(data.valueInr) }],
      });
    },
    addToCart: function (data) {
      return trackPixel('AddToCart', {
        content_type: 'product',
        content_ids: [String(data.variantId)],
        content_name: data.title || '',
        value: Number(data.valueInr),
        currency: 'INR',
        contents: [{ id: String(data.variantId), quantity: data.qty || 1, item_price: Number(data.valueInr) }],
      });
    },
    lead: function (data) {
      return trackPixel('Lead', {
        content_name: (data && data.content_name) || 'Pre-purchase consult',
        currency: 'INR',
        value: 0,
      });
    },
  };

  function setText(sel, txt) {
    document.querySelectorAll(sel).forEach(function (el) {
      el.textContent = txt;
    });
  }

  function getActiveBundle() {
    return document.querySelector('#nl-bundles .nl-bundle.is-active');
  }

  function getSelectedVariantId() {
    var card = getActiveBundle();
    if (!card) return null;
    return parseInt(gidNum(card.dataset.vid), 10) || null;
  }

  function updateBuyBox(card, options) {
    if (!card) return;
    options = options || {};
    var price = card.dataset.priceFormatted;
    var compare = card.dataset.compareFormatted;
    var save = card.dataset.saveFormatted;
    var perday = card.dataset.perday;
    var courseLabel = card.dataset.courseLabel;
    var pricePaise = card.dataset.price;
    var vidNum = gidNum(card.dataset.vid);

    setText('.nl-price__now', price);
    setText('[data-nl-sticky-price]', price);
    setText('[data-nl-sticky-price-mobile]', price);

    document.querySelectorAll('.nl-price__was').forEach(function (el) {
      el.textContent = compare || '';
      el.hidden = !compare;
    });
    document.querySelectorAll('.nl-price__save').forEach(function (el) {
      if (save) {
        el.textContent = 'SAVE ' + save;
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    });
    document.querySelectorAll('.nl-price__perday').forEach(function (el) {
      if (perday && courseLabel) {
        el.textContent = perday + ' · ' + courseLabel;
        el.hidden = false;
      } else if (perday) {
        el.textContent = perday;
        el.hidden = false;
      } else {
        el.textContent = '';
        el.hidden = true;
      }
    });

    setText('.included-variant', card.dataset.meta || '');
    var incPrice = document.querySelector('.included-price');
    if (incPrice) {
      var cmp = incPrice.querySelector('.included-compare');
      incPrice.childNodes.forEach(function (node) {
        if (node.nodeType === 3) node.textContent = price + ' ';
      });
      if (cmp) {
        cmp.textContent = compare || '';
        cmp.hidden = !compare;
      }
    }

    // Keep the dedicated Shopify checkout form on the selected course.
    document.querySelectorAll('[data-nl-cart-variant-id]').forEach(function (el) {
      el.disabled = false;
      el.value = String(vidNum);
    });

    try {
      var u = new URL(location.href);
      u.searchParams.set('variant', String(vidNum));
      history.replaceState({}, '', u);
    } catch (e) {}

    document.querySelectorAll('#nl-bundles .nl-bundle').forEach(function (c) {
      c.classList.remove('is-active');
    });
    card.classList.add('is-active');

    if (window.NLLactationPixel && options.trackView) {
      window.NLLactationPixel.viewContent({
        variantId: vidNum,
        title: card.dataset.vtitle,
        valueInr: Number(pricePaise) / 100,
      });
    }
  }

  function initBundles() {
    var root = document.getElementById('nl-bundles');
    if (!root) return;

    var checked =
      root.querySelector('input[name="nl-bundle"]:checked') ||
      root.querySelector('input[name="nl-bundle"]');
    if (checked) {
      checked.checked = true;
      updateBuyBox(checked.closest('.nl-bundle'), { trackView: true });
    }

    root.querySelectorAll('input[name="nl-bundle"]').forEach(function (r) {
      r.addEventListener('change', function () {
        updateBuyBox(r.closest('.nl-bundle'), { trackView: false });
      });
    });
  }

  function refreshDrawerAndCount() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + '?section_id=cart-drawer', { credentials: 'same-origin' })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextDrawer = doc.getElementById('MinimogCartDrawer');
        var drawer = document.getElementById('MinimogCartDrawer');
        if (drawer && nextDrawer) {
          drawer.innerHTML = nextDrawer.innerHTML;
        }

        return fetch(root + '?section_id=cart-count', { credentials: 'same-origin' });
      })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextCount = doc.querySelector('m-cart-count');
        if (!nextCount) return;
        document.querySelectorAll('m-cart-count').forEach(function (count) {
          count.textContent = nextCount.textContent.trim();
          count.classList.toggle('m:hidden', nextCount.classList.contains('m:hidden'));
        });
      });
  }

  function initNativeAtc() {
    var form = document.querySelector('[data-nl-native-cart-form]');
    if (!form) return;

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var card = getActiveBundle();
      var variantId = getSelectedVariantId();
      var quantityInput = form.querySelector('[name="quantity"]');
      var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
      if (!quantity || quantity < 1) quantity = 1;
      if (!variantId) return;

      form.querySelector('[data-nl-cart-variant-id]').value = String(variantId);

      if (window.NLLactationPixel && card && variantId) {
        var eventID = window.NLLactationPixel.addToCart({
          variantId: variantId,
          title: card.dataset.vtitle || '',
          valueInr: (Number(card.dataset.price) / 100) * quantity,
          qty: quantity,
        });
        try {
          sessionStorage.setItem('nl_meta_event_id', eventID);
          sessionStorage.setItem('nl_meta_event_name', 'AddToCart');
        } catch (err) {}
      }

      var submitter = event.submitter;
      var isDirectCheckout = submitter && submitter.name === 'nl_direct_checkout';
      var buttons = form.querySelectorAll('button[type="submit"]');
      buttons.forEach(function (button) {
        button.disabled = true;
      });

      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var addUrl =
        window.MinimogSettings && MinimogSettings.routes && MinimogSettings.routes.cart_add_url
          ? MinimogSettings.routes.cart_add_url
          : root + 'cart/add.js';
      if (addUrl.indexOf('.js') === -1) addUrl += '.js';

      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: [{ id: variantId, quantity: quantity }],
        }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data.status || data.errors) {
            throw new Error(data.description || data.message || 'Cart error');
          }

          if (isDirectCheckout) {
            window.location.assign(root + 'checkout');
            return;
          }

          return refreshDrawerAndCount().then(function () {
            var drawer = document.querySelector('m-cart-drawer');
            if (drawer && typeof drawer.open === 'function') {
              drawer.open(submitter || null);
            } else {
              window.location.assign(root + 'cart');
            }
          });
        })
        .catch(function () {
          // Native form post is the safe fallback if AJAX fails.
          form.submit();
        })
        .finally(function () {
          buttons.forEach(function (button) {
            button.disabled = false;
          });
        });
    });
  }

  function initTabs() {
    var nav = document.querySelector('.nl-tabs__nav');
    if (!nav) return;
    nav.querySelectorAll('.nl-tabs__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.dataset.tab;
        nav.querySelectorAll('.nl-tabs__btn').forEach(function (b) {
          b.classList.remove('is-active');
        });
        document.querySelectorAll('.nl-tabs__pane').forEach(function (p) {
          p.classList.remove('is-active');
        });
        btn.classList.add('is-active');
        var pane = document.getElementById('nl-tab-' + target);
        if (pane) pane.classList.add('is-active');
        btn.scrollIntoView({ inline: 'center', behavior: 'smooth', block: 'nearest' });
      });
    });
  }

  function initConsultLead() {
    document.querySelectorAll('[data-nl-consult-lead]').forEach(function (el) {
      el.addEventListener('click', function () {
        if (window.NLLactationPixel) {
          window.NLLactationPixel.lead({ content_name: 'Lactation pre-purchase consult' });
        }
      });
    });
  }

  function boot() {
    initBundles();
    initTabs();
    initConsultLead();
    initNativeAtc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
